module.exports = __webpack_public_path__ + "img/icon_sub_arrow_on.66a05ac5.66a05ac5.svg";